module.exports = __webpack_public_path__ + "static/media/renalcancer.dddcca56.svg";